<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="user-title">
      <div class="user-line"></div>
      <div class="user-text">我的团队 </div>
    </div>

    <!-- 超级管理员 -->
    <div v-show="duty == 3 && !teamId">
      <van-search v-model="value" shape="round" @search="onSearch" placeholder="请输入团队成员名称" style="margin-top: 12px;" />

      <van-pull-refresh v-model="refreshingBoss" @refresh="onRefreshBoss" style="margin-top: 12px;">
        <van-list v-model="loadingBoss" :finished="finishedBoss" finished-text="没有更多了" @load="onLoadBoss"
          :immediate-check=false>
          <van-cell-group v-for="(item, index) in listBoss" :key="index" style="margin-bottom: 6px;">
            <van-cell title="团队名称" :value="item.enterpriseName" :border="false" />
            <van-cell title="负责人名称" :value="item.userStr" :border="false" />
            <van-cell title="负责人电话" :value="item.phone" :border="false" />
            <van-cell title="团队人数" :value="item.count" :border="false" />
            <van-cell title="团队完成总单数" :value="item.orderCount" :border="false" />
            <van-cell title="团队完成总金额" :value="item.amount" :border="false" />
            <van-cell title="客户数量" :value="item.clientCount" :border="false" />
            <div class="user-center">
              <div style="color: #3a71ffff" @click="onClickTeamDetail(item)">点击查看详情>></div>
            </div>
          </van-cell-group>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 负责人 或者 超级管理员查看详情 -->
    <div v-show="duty == 99 || teamId">
      <van-cell-group title="团队信息">
        <van-cell title="团队名称" :value="corporationData.enterpriseName" :border="false" />
        <van-cell title="负责人名称" :value="corporationData.userStr" :border="false" />
        <van-cell title="负责人电话" :value="corporationData.phone" :border="false" />
        <van-cell title="团队人数" :value="corporationData.count" :border="false" />
        <van-cell title="团队完成总单数" :value="corporationData.orderCount" :border="false" />
        <van-cell title="团队完成总金额" :value="corporationData.amount" :border="false" />
        <van-cell title="客户数量" :value="corporationData.clientCount" :border="false" />
      </van-cell-group>

      <van-search v-model="value" shape="round" @search="onSearch" placeholder="请输入团队成员名称" style="margin-top: 12px;" />
      <van-tabs v-model="active" color="#3a71ffff" title-active-color="#3a71ffff" @click="onTabClick">
        <van-tab v-for="(item, index) in listTabDepartment" :key="index" :title="item.name">
        </van-tab>
      </van-tabs>

      <van-pull-refresh v-model="refreshingDepartment" @refresh="onRefreshDepartment" style="margin-top: 12px;">
        <van-list v-model="loadingDepartment" :finished="finishedDepartment" finished-text="没有更多了"
          @load="onLoadDepartment" :immediate-check=false>
          <van-cell-group v-for="(item, index) in listDepartment" :key="index" style="margin-bottom: 6px;">
            <van-cell :value="getOrderCount(item)" :border="false">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <div class="user-tags" @click="onClickName(item)">
                  <div style="color: #3a71ffff">{{ item.name }}</div>
                  <div style="color: #3a71ffff" v-show="getIsLeader(item)">&nbsp;&nbsp;&nbsp;组长</div>
                </div>
              </template>
            </van-cell>
            <van-cell title="完成总金额" :value="item.amount" :border="false" />
            <van-cell title="电话" :value="item.account" :border="false" />
          </van-cell-group>
        </van-list>
      </van-pull-refresh>
      <div class="footer" v-show="getPermission()">
        <van-button round type="info" @click="onClickManage">团队管理</van-button>
      </div>
    </div>

  </van-col>
</template>

<script>

import request from "@/utils/request";
import user from '@/utils/user'


export default {
  props: {
    teamId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      value: '',
      corporationData: '',
      active: 0,
      duty: -1,
      listBoss: [],
      loadingBoss: false,
      finishedBoss: false,
      refreshingBoss: false,
      listQueryBoss: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        firmId: "",
      },
      departmentId: "",
      firmId: "",
      listDepartment: [],
      listTabDepartment: [],
      loadingDepartment: false,
      finishedDepartment: false,
      refreshingDepartment: false,
      listQueryDepartment: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        departmentId: "",
        firmId: "",
      },
    };
  },
  created() {
    this.duty = user.getUserDuty()
    this.firmId = user.getUserFirmId()

    if (this.teamId) {
      this.firmId = this.teamId
    }

    if (this.duty == 3 && !this.teamId) {
      this.onRefreshBoss()
    } else if (this.duty == 99 || this.teamId) {
      this.getCorporationClient()
      this.onLoadDepartmentTab()
    } else {
      this.$router.replace({ name: 'noPermission' });
    }
  },
  methods: {
    onTabClick(val) {
      this.departmentId = this.listTabDepartment[val].id
      this.onRefreshDepartment()
    },
    onSearch(val) {
      this.$router.push({
        path: 'myClient',
        query: { nameLike: val }
      })
    },
    onClickName(item) {
      this.$router.push({
        path: 'myClient',
        query: { salesmanId: item.id }
      })
    },
    onClickTeamDetail(item) {
      this.$router.push({
        path: 'team',
        query: { teamId: item.id }
      })
    },
    getPermission() {
      return this.duty == 3 || this.duty == 99
    },
    getOrderCount(item) {
      return '完成单数' + item.orderCount + '单'
    },
    getIsLeader(item) {
      var userId = this.listTabDepartment[this.active].userId
      return item.id === userId
    },
    onClickManage() {
      this.$router.push({
        path: 'teamManage',
        query: { firmId: this.firmId }
      })
    },
    /**
     * 获取公司信息
     */
    getCorporationClient() {
      request.get("/User/MyTeam/CorporationClient", { params: { firmId: this.firmId } })
        .then((res) => {
          this.corporationData = res.data.data
        }).catch(() => {
        });
    },
    onLoadBoss() {
      if (this.refreshingBoss) {
        this.listBoss = [];
        this.refreshingBoss = false;
        this.listQueryBoss.page = 1;
      }

      var filterFomr = Object.assign({}, this.listQueryBoss);
      request.post("/User/MyTeam/AdminClient", filterFomr).then((res) => {
        this.listQueryBoss.page = res.data.data.pageInfo.page + 1;
        this.listBoss = res.data.data.data;
        this.finishedBoss = !res.data.data.pageInfo.hasMore;
        this.loadingBoss = false;
      }).catch(() => {
        this.loadingBoss = false;
      });
    },
    onRefreshBoss() {
      this.listQueryBoss.firmId = this.firmId;
      // 清空列表数据
      this.finishedBoss = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loadingBoss = true;
      this.onLoadBoss();
    },
    onLoadDepartmentTab() {
      request.get("/User/Department/GetDepartmentList", { params: { firmId: this.firmId } })
        .then((res) => {
          this.listTabDepartment = res.data.data
          if (this.listTabDepartment.length > this.active) {
            this.departmentId = this.listTabDepartment[this.active].id
            this.onRefreshDepartment()
          }
        }).catch(() => {
        });
    },
    onLoadDepartment() {
      if (this.refreshingDepartment) {
        this.listDepartment = [];
        this.refreshingDepartment = false;
        this.listQueryDepartment.page = 1;
      }

      var filterFomr = Object.assign({}, this.listQueryDepartment);
      request.post("/User/MyTeam/DepartmentUserList", filterFomr).then((res) => {
        this.listQueryDepartment.page = res.data.data.pageInfo.page + 1;
        this.listDepartment = res.data.data.data;
        this.finishedDepartment = !res.data.data.pageInfo.hasMore;
        this.loadingDepartment = false;
      }).catch(() => {
        this.loadingDepartment = false;
      });
    },
    onRefreshDepartment() {
      // 清空列表数据
      this.listQueryDepartment.firmId = this.firmId;
      this.listQueryDepartment.departmentId = this.departmentId;

      // 清空列表数据
      this.finisheDepartment = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loadingDepartment = true;
      this.onLoadDepartment();
    },
  }
};
</script>

<style lang="less">
.user-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.user-tags {
  display: flex;
  align-items: center;
}

.user-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.user-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.user-text {
  color: #333;
  margin-left: 6px;
}

.user-content {
  padding-right: 20px;
  text-align: right;
  color: #333;
  border: none;
  width: 95%;
}

.footer {
  position: fixed;
  bottom: 62px;
  right: 12px;
  width: 100%;
  text-align: right;
  /* 如果你想让按钮居中 */
}
</style>
